import apiService from "./apiService";
import { AllergyCatalogDTO } from "@sizdevteam1/funjoiner-web-shared/features/medical/baseline-questions/allergies/AllergyBaselineQuestion";
import { MedicalConditionCatalogDTO } from "@sizdevteam1/funjoiner-web-shared/features/medical/baseline-questions/medical-conditions/MedicalConditionBaselineQuestion";
import { DisabilityCatalogDTO } from "@sizdevteam1/funjoiner-web-shared/features/medical/baseline-questions/disabilities/DisabilityBaselineQuestion";
import { MedicationCatalogDTO } from "@sizdevteam1/funjoiner-web-shared/features/medical/baseline-questions/medications/MedicationBaselineQuestion";

export type MedicalCatalogsDTO = {
  allergies: AllergyCatalogDTO;
  medical_conditions: MedicalConditionCatalogDTO;
  disabilities: DisabilityCatalogDTO;
  medications: MedicationCatalogDTO;
};
export const getAll = () => {
  return apiService.get<MedicalCatalogsDTO>(
    "/customer_api/v2/medical_catalogs/all_catalogs",
  );
};
